import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for generating tokens.
 * @extends JetView
 */
export default class FilterGenerateTokenView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Make the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Additional right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left and a spacer
        const upper_section = {
            cols: [
                center_left,
                { gravity: 2, minWidth: 10 }, // Spacer with gravity
            ],
        };

        // Button section with action buttons
        const buttons = {
            margin: 2,
            cols: [
                {},
                {
                    view: 'button', // Button to generate token
                    value: _('Generar Token'), // Button label
                    width: 120,
                    click: () => {
                        const cur_user = this.getParam('league', true); // Get current user ID
                        const filterdata = this.getRoot().getValues(); // Get form values
                        var thisClick = this; // Reference to current context

                        // AJAX request to save user security
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurity', // API endpoint
                                '{ "UserId":' + cur_user + '}', // Request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        webix.message('Saved'); // Show success message
                                        thisClick.app.callEvent('generateTokenAgentList:filter', [filterdata]); // Trigger filter event
                                    },
                                },
                            );
                    },
                },
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'), // Button label
                    width: 66,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult/filter
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    width: 84,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('generateToken:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Layout rows
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
